import { IPlayerTemplate } from '../../types/player';
import { setColorAlpha } from '@voomly/ui/player-deps';
export const DEFAULT_BG_COLOR = '#000000';

export const getBgColor = (config: IPlayerTemplate) => {
  return config.appearance.bgColorEnabled
    ? config.appearance.bgColor || DEFAULT_BG_COLOR
    : DEFAULT_BG_COLOR;
};

export const getBgColorWithoutOpacity = (config: IPlayerTemplate) => {
  return config.appearance.bgColorEnabled
    ? setColorAlpha(config.appearance.bgColor, 1) || DEFAULT_BG_COLOR
    : DEFAULT_BG_COLOR;
};
